/**
 * Created by Tiger on 01/03/2022.
 */

import Types from '../../action/types';

const defaultState = {
  tableLoading: true,
  total: 0,
  currentPage: 1,
  pageSize: 50,
  deviceList: [],
  notPrivateDeviceListLoading: true,
  notPrivateDeviceListTotal: 0,
  notPrivateDeviceList: [],
  notPrivateDeviceListCurrentPage: 1,
  notPrivateDeviceListPageSize: 20,
};

export default function onAction(state = defaultState, action) {
  switch (action.type) {
    case Types.REFRESH_DEVICE_LIST:
      return { ...defaultState, ...state, tableLoading: true };
    case Types.REFRESH_DEVICE_LIST_SUCCESS:
      return { ...state, tableLoading: false, ...action };
    case Types.REFRESH_DEVICE_LIST_FAIL:
      return { ...state, tableLoading: false };
    case Types.REFRESH_NOT_PRIVATE_LIST:
      return { ...state, notPrivateDeviceListLoading: true };
    case Types.REFRESH_NOT_PRIVATE_LIST_SUCCESS:
      return { ...state, ...action, notPrivateDeviceListLoading: false };
    case Types.REFRESH_NOT_PRIVATE_LIST_FAIL:
      return { ...state, notPrivateDeviceListLoading: false };
    default:
      return { ...state };
  }
}